export default __webpack_public_path__ + "static/media/right-join.d89bf9bc.svg";